"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowBack = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ArrowBack = function ArrowBack(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.806 5.29628L4.79628 11.306C4.60666 11.494 4.5 11.7501 4.5 12.0171C4.5 12.2842 4.60666 12.5402 4.79628 12.7283L10.806 18.738C11.1987 19.128 11.8333 19.1257 12.2233 18.733C12.6132 18.3402 12.611 17.7057 12.2183 17.3157L7.90129 13.0187H18.4984C19.0516 13.0187 19.5 12.5703 19.5 12.0171C19.5 11.4639 19.0516 11.0155 18.4984 11.0155H7.90129L12.2183 6.71857C12.4094 6.5312 12.5176 6.2751 12.5187 6.00742C12.5203 5.74119 12.4158 5.4853 12.2283 5.29628C12.0402 5.10666 11.7842 5 11.5171 5C11.2501 5 10.994 5.10666 10.806 5.29628Z"
  }));
};

exports.ArrowBack = ArrowBack;